module.exports = __webpack_public_path__ + "cv.b4f5c1e96acbd6cdb9b3.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/cv.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/cv.svg
// module chunks = styles